export default {
  hint: 'Confirmez le paiement auprès de votre banque pour finaliser votre commande.',
  cancel: 'Annuler le paiement',
};
